import './WindowControls.scss';

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { isElectron } from '../../utils/electron';

const riverOS = () => (window as any).riverOS;

const MinimizeIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <rect x="0" y="4.5" width="10" height="1" rx="0.5" fill="currentColor" />
  </svg>
);

const MaximizeIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <rect x="0.5" y="0.5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1" />
  </svg>
);

const RestoreIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <rect x="2.5" y="0.5" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1" />
    <path d="M0.5 3v6.5H7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const WindowControls: React.FC = () => {
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    const os = riverOS();
    if (!os?.window) return;

    os.window.isMaximized().then((val: boolean) => setIsMaximized(val));
    const unsubscribe = os.window.onMaximizeChange((val: boolean) => setIsMaximized(val));
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!isElectron() || riverOS()?.platform === 'darwin') return;
    // Mark <html> so CSS can apply border-radius + overflow:hidden
    document.documentElement.classList.add('electron-frameless');
    return () => document.documentElement.classList.remove('electron-frameless');
  }, []);

  // Only render on Linux/Windows inside Electron
  if (!isElectron() || riverOS()?.platform === 'darwin') return null;

  const os = riverOS();

  return ReactDOM.createPortal(
    <div className="window-controls">
      <button
        className="window-controls__btn window-controls__btn--minimize"
        onClick={() => os?.window?.minimize()}
        aria-label="Minimize"
        title="Minimize"
      >
        <MinimizeIcon />
      </button>

      <button
        className="window-controls__btn window-controls__btn--maximize"
        onClick={() => os?.window?.maximize()}
        aria-label={isMaximized ? 'Restore' : 'Maximize'}
        title={isMaximized ? 'Restore' : 'Maximize'}
      >
        {isMaximized ? <RestoreIcon /> : <MaximizeIcon />}
      </button>

      <button
        className="window-controls__btn window-controls__btn--close"
        onClick={() => os?.window?.close()}
        aria-label="Close"
        title="Close"
      >
        <CloseIcon />
      </button>
    </div>,
    document.body
  );
};

export default WindowControls;
